<template>
  <div class="filter-list">
    <div
      class="filter-list__overlay"
      @click="closeFilter"
    />

    <div class="filter-list__wrapper">
      <div class="filter-list__main">
        <div class="filter-list__headline">
          <UiBtn
            color="default"
            icon="common/close"
            @click="write_filterOptions({ isOpen: false })"
          />
        </div>

        <div class="filter-list__content">
          <div class="filter-list__scroll-content">
            <div v-if="get_presetFilters.isLoading && !presetFiltersData" class="filter-list__loading" />

            <template v-for="item in presetFiltersData">
              <FilterPopular
                v-if="item.isPopular"
                :key="item.template"
                ref="popularRef"
                v-model="filterPopular"
                :data="item"
              />

              <FilterRate
                v-if="item.isRate"
                :key="item.template"
                ref="filterRateRef"
                v-model="filterRate"
                :data="item"
              />

              <FilterProviders
                v-if="item.isProviders"
                :key="item.template"
                ref="filterProvidersRef"
                v-model="filterProviders"
                :data="item"
              />
            </template>
          </div>
        </div>

        <div class="filter-list__footer">
          <UiBtn
            class="filter-list__footer-btn"
            color="gray"
            :text="$tc('lobby.filter.cancel')"
            @click="onClearFilters"
          />

          <UiBtn
            class="filter-list__footer-btn"
            color="primary"
            :text="$tc('lobby.filter.submit')"
            :loading="isSendingData"
            @click="sendData"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { disablePageScroll, enablePageScroll, addScrollableSelector, removeScrollableSelector } from 'scroll-lock'
import { FILTER, PARAM_SUB_PAGE } from '@/components/Lobby/enum.js'
import FilterPopular from '@/components/Lobby/FilterList/FilterPopular'
import FilterRate from '@/components/Lobby/FilterList/FilterRate'
import FilterProviders from '@/components/Lobby/FilterList/FilterProviders'
const SCROLLABLE_CONTENT_SELECTOR = '.filter-list__scroll-content'
const SCROLLABLE_PROVIDERS_SELECTOR = '.filter-providers__list'

export default {
  name: 'FilterListInner',
  components: {
    FilterPopular,
    FilterRate,
    FilterProviders,
  },
  data() {
    return {
      filterPopular: {},
      filterRate: {},
      filterProviders: {},
    }
  },
  computed: {
    ...mapGetters('user', [
      'isLoggedIn',
    ]),
    ...mapGetters('lobby', [
      'get_presetFilters',
      'get_filterType',
      'get_subsectionItem',
      'get_filterOptions',
    ]),
    presetFiltersData() {
      return this.get_presetFilters.data?.map((el) => {
        return {
          ...el,
          isPopular: el.template === FILTER.TEMPLATE.POPULAR,
          isRate: el.template === FILTER.TEMPLATE.SIZE_BET,
          isProviders: el.template === FILTER.TEMPLATE.PROVIDER && el.data[0]?.providers?.length,
        }
      })
    },
    isSendingData() {
      return this.get_subsectionItem.isLoading
    },
    filters() {
      const filterObject = (obj) => {
        return Object.fromEntries(Object.entries(obj).filter(([_, value]) => Boolean(value)))
      }

      const filters = {
        ...this.filterPopular,
        ...this.filterRate,
        ...this.filterProviders,
      }

      return filterObject(filters)
    },
    filterType() {
      return this.get_filterType(this.$route)
    },
  },
  beforeMount() {
    addScrollableSelector(SCROLLABLE_CONTENT_SELECTOR)
    addScrollableSelector(SCROLLABLE_PROVIDERS_SELECTOR)
    disablePageScroll()
  },
  mounted() {
    this.initFilters()
  },
  beforeDestroy() {
    this.closeFilter()
    removeScrollableSelector(SCROLLABLE_CONTENT_SELECTOR)
    removeScrollableSelector(SCROLLABLE_PROVIDERS_SELECTOR)
    enablePageScroll()
  },
  methods: {
    ...mapActions('lobby', [
      'fetch_presetFilters',
      'write_filterOptions',
    ]),
    closeFilter() {
      this.write_filterOptions({ isOpen: false })
    },
    sendData() {
      const filters = {
        filterPopular: { ...this.filterPopular },
        filterRate: { ...this.filterRate },
        filterProviders: { ...this.filterProviders },
      }

      this.write_filterOptions({ selected: filters, term: this.$route.params[PARAM_SUB_PAGE] })
      this.$nuxt.$emit(FILTER.EVENT, this.filters)

      this.closeFilter()
    },
    async initFilters() {
      if (this.get_filterOptions.isFiltered) return
      await this.fetch_presetFilters({
        preset: FILTER.PRESET.DEFAULT_GAMES,
        mode: FILTER.MODE.SIMPLE,
        type: this.filterType,
        term: this.$route.params[PARAM_SUB_PAGE],
      })
    },
    onClearFilters() {
      this.$refs.popularRef && this.$refs.popularRef[0].reset()
      this.$refs.filterRateRef && this.$refs.filterRateRef[0].reset()
      this.$refs.filterProvidersRef && this.$refs.filterProvidersRef[0].reset()

      this.filterPopular = {}
      this.filterRate = {}
      this.filterProviders = {}
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
